<template>
  <footer :class="footerClass">
    <p class="copyright" v-html="$t('copyright_2020_knock_on_the_door')"></p>
    <ul class="f-menu">
      <li>
        <router-link :to="'/legal/termsofuse'" target="_blank">{{ $t('terms_of_service') }}</router-link>
      </li>
      <li><a href="https://knockonthedoor.jp/privacy/" target="_blank">{{ $t('privacy_policy') }}</a></li>
      <li v-if="$store.state.auth.typeOfUser !== 'pharmacy'">
        <router-link :to="'/info'">{{ $t('about_service') }}</router-link>
      </li>
      <li>
        <router-link :to="'/contact-form'">{{ $t('contact') }}</router-link>
      </li>
    </ul>
  </footer>
</template>

<script>
  import { isLogin } from "@/js/commons/commons"
  export default {
    data() {
      return {
        footerClass: 'clearfix',
      }
    },
    created() {
      if (isLogin()) {
        this.footerClass = 'clearfix f-solid'
      }
    }
  }
</script>